














import { HighlightsButtonMeta } from '@front-app/modules/group/highlights/model';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import BaseButtonRender from './BaseButtonRender.vue';

export default defineComponent({
	components: {
		BaseButtonRender,
	},
	props: {
		meta: {
			type: Object as PropType<HighlightsButtonMeta>,
			required: true,
		},
	},
	setup(props) {
		const href = computed(() => `/app/createConversation.shtml?preSelectedIds=${props.meta.userId}`);
		return {
			href,
		};
	},
});
